import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ErrorPageType } from 'src/app/helpers/enum/error-page-type.enum';

export const onlineGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (navigator.onLine) {
    return true;
  }

  router.navigate(['/error'], {
    queryParams: { type: ErrorPageType.NETWORK_ERROR }
  });

  return false;
};